import Repository from '@/api/core'
const baseURL = process.env.VUE_APP_API_ANONYMOUS_PAYMENT + '/cart-link'
const UserCartLink = process.env.VUE_APP_API_ANONYMOUS_PAYMENT + '/user-cart-link'
import utils from '@/helpers/utils.js'

const fetch = params => {
  return Repository(baseURL).fetch(params)
}

const fetchOne = id => {
  return Repository(baseURL).fetchOne(id)
}

const create = params => {
  return Repository(baseURL).create(params)
}

const update = (id, params) => {
  return Repository(baseURL).update(id, params)
}

const remove = id => {
  return Repository(baseURL).delete(id)
}

const count = params => {
  return Repository(baseURL + '/count').fetch({...utils.cleanObject(params)})
}
const fetchUserCartLink = params => {
  return Repository(UserCartLink).fetch(params)
}
const countUserCartLink = params => {
  return Repository(UserCartLink + '/count').fetch({...utils.cleanObject(params)})
}
export default {
  fetch,
  fetchOne,
  create,
  update,
  remove,
  count,
  fetchUserCartLink,
  countUserCartLink,
}
